import { MuscleCategories, MuscleLabelInfo } from '../type'
import { musclesCategorized } from '../config/categories'
import { MuscleLabelColors } from '@entities/muscle/config/colors'
import { getCurrentBackendLocale } from '@shared/i18n'
import { Language } from '@shared/types/language'

export class MuscleService {
	private static readonly musclesCategorized_: Readonly<MuscleCategories> = [
		...musclesCategorized,
	]

	public static getGroupCodesFromMuscleCodes = (codes: string[]): string[] => {
		const blockNames: string[] = []
		for (const group of this.musclesCategorized_) {
			for (const muscle of group.muscles) {
				if (codes.includes(muscle.code)) {
					blockNames.push(group.group_code)
					break
				}
			}
		}
		return blockNames
	}

	public static getMuscleCodesFromGroupCode = (groupCode: string): string[] => {
		const muscleCodes: string[] = []
		for (const group of this.musclesCategorized_) {
			if (group.group_code === groupCode) {
				for (const muscle of group.muscles) {
					muscleCodes.push(muscle.code)
				}
				return muscleCodes
			}
		}
		throw new Error(`Group with code ${groupCode} not found`)
	}

	public static getMuscleLabelInfo = (muscleGroupCode: string): MuscleLabelInfo => {
		return {
			name: MuscleService.getNameFromCode(muscleGroupCode, getCurrentBackendLocale()),
			backgroundColor: MuscleLabelColors[muscleGroupCode] || '#000',
		}
	}

	public static getMuscleLabelInfoFromMuscleCode = (
		muscleCode: string,
		name: Language = getCurrentBackendLocale()
	): MuscleLabelInfo => {
		const groupCode = MuscleService.getGroupCodesFromMuscleCodes([muscleCode])[0]

		return {
			name: MuscleService.getNameFromCode(muscleCode, name),
			backgroundColor: MuscleLabelColors[groupCode] || '#000',
		}
	}

	public static getNameFromCode = (groupCode: string, lang: Language): string => {
		for (const group of MuscleService.musclesCategorized_) {
			if (group.group_code === groupCode) {
				return lang === 'ru' ? group.group_name_ru : group.group_name_en
			}
			for (const muscle of group.muscles) {
				if (muscle.code === groupCode) {
					return lang === 'ru' ? muscle.name_ru : muscle.name_en
				}
			}
		}
		throw new Error(`Group with code ${groupCode} not found`)
	}

	public static getMuscleLabelsParentsInfo = (
		muscleCodes: string[],
		lang: Language = getCurrentBackendLocale()
	): MuscleLabelInfo[] => {
		const parentLabels: MuscleLabelInfo[] = []
		const addedGroupCodes = new Set<string>()

		for (const muscleCode of muscleCodes) {
			for (const group of MuscleService.musclesCategorized_) {
				for (const muscle of group.muscles) {
					if (muscle.code === muscleCode) {
						if (!addedGroupCodes.has(group.group_code)) {
							parentLabels.push({
								name: lang === 'ru' ? group.group_name_ru : group.group_name_en,
								backgroundColor: MuscleLabelColors[group.group_code] || '#000',
							})
							addedGroupCodes.add(group.group_code)
						}
					}
				}
			}
		}

		return parentLabels
	}
}
